import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, className = "", ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function SectionHead({ eyebrow, title, testid }) {
  return (
    <div className="mb-14 md:mb-20 max-w-3xl">
      <Reveal>
        <p className="eyebrow mb-5">{eyebrow}</p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2
          data-testid={testid}
          className="font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight leading-[1.05] text-ink"
        >
          {title}
        </h2>
      </Reveal>
    </div>
  );
}
